import { service } from "@/api/service ";
import { toastError, toast } from "@/components/custom/Toast";

const state = {
  Rbtypes: [],
  trSettings: [],
  empReviewSettingArray: [],
  empReviewSetting: null,
  pagination: {},
  addStatus: false,
  editStatus: false,
  deleteStatus: false,
  editTrStatus: false,
  editEmpReviewSetting: false,
};
const getters = {
  RbtypesListGet: (state) => state.Rbtypes,
  trSettingsGet: (state) =>
    state.trSettings.map((obj) =>
      obj.value == 0
        ? { ...obj, value: "No" }
        : obj.value == 1
        ? { ...obj, value: "Yes" }
        : { ...obj, value: obj.value }
    ),
  empReviewSettingListGet: (state) => state.empReviewSettingArray,
  empReviewSettingGet: (state) => state.empReviewSetting,
};
const actions = {
  async getRb({ commit }) {
    await service.getFun(`rbtypes`).then(
      (obj) => {
        var result = obj.data;
        commit("RbtypesListSet", result);
      },
      (error) => {
        console.log("Rbtypes..." + error);
        toastError(error);
      }
    );
  },

  async addRbtypes({ commit }, payload) {
    await service
      .postFun(service.deleteNullValues(payload), `rbtypes`, null, {
        action: "getRb",
      })
      .then(
        (result) => {
          commit("addRbtypestatus", result.success);
          toast(result.message);
        },
        (error) => {
          console.log("courses..." + error);
          toastError(error);
        }
      );
  },
  editRbtypes({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `rbtypes/${payload.id}`,
        null,
        {
          action: "getRb",
        }
      )
      .then(
        (result) => {
          commit("editRbtypestatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
  deleteRbtypes({ commit }, payload) {
    service
      .deleteFun(`rbtypes/${payload.payload}`, {
        action: "getRb",
      })
      .then(
        (result) => {
          commit("editRbtypestatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
  async geytrSettings({ commit }) {
    await service.getFun(`settings`).then(
      (obj) => {
        var result = obj.data;
        commit("trSettingList", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  editTrSetting({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `settings`, null, {
        action: "geytrSettings",
      })
      .then(
        (result) => {
          commit("edittrSettingStatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
  async getEmpReviewSetting({ commit }) {
    await service.getFun(`review-factors`).then(
      (obj) => {
        var result = obj.data;
        commit("empReviewSetting", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  async getEmpRvSettingById({ commit }, payload) {
    await service.getFun(`review-factors/${payload}`).then(
      (obj) => {
        var result = obj.data;
        commit("empRvSettingByIdSet", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },

  addEmpRvSetting({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `review-factors`, null, {
        action: "getEmpReviewSetting",
      })
      .then(
        (result) => {
          commit("empReviewSetting", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },

  editEmpRvSetting({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `review-factors/${payload.id}`,
        null,
        {
          action: "getEmpReviewSetting",
        }
      )
      .then(
        (result) => {
          commit("edittrSettingStatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
};
const mutations = {
  RbtypesListSet(state, Rbtypes) {
    state.Rbtypes = Rbtypes;
  },
  trSettingList(state, trSettings) {
    state.trSettings = trSettings;
  },
  getRbtypesById(state, Rbtypes) {
    state.Rbtypes = Rbtypes;
  },
  addRbtypestatus(state, Status) {
    state.addStatus = Status;
  },
  editRbtypestatus(state, Status) {
    state.editStatus = Status;
  },
  edittrSettingStatus(state, Status) {
    state.editTrStatus = Status;
  },
  empReviewSetting(state, Status) {
    state.empReviewSettingArray = Status;
  },
  empRvSettingByIdSet(state, empReviewSetting) {
    state.empReviewSetting = empReviewSetting;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
